var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46429 4.23214H12.6964V0H8.46429V4.23214ZM16.9286 4.23214V0H21.1607V4.23214H16.9286ZM8.46429 21.1607V16.9286H12.6964V21.1607H8.46429ZM25.3929 12.6964V8.46429H29.625V12.6964H25.3929ZM25.3929 21.1607V16.9286H29.625V21.1607H25.3929ZM16.9286 21.1607V16.9286H21.1607V21.1607H16.9286ZM25.3929 4.23214V0H29.625V4.23214H25.3929ZM12.6964 8.46429V4.23214H16.9286V8.46429H12.6964ZM0 33.8571V0H4.23214V4.23214H8.46429V8.46429H4.23214V12.6964H8.46429V16.9286H4.23214V33.8571H0ZM21.1607 16.9286V12.6964H25.3929V16.9286H21.1607ZM12.6964 16.9286V12.6964H16.9286V16.9286H12.6964ZM8.46429 12.6964V8.46429H12.6964V12.6964H8.46429ZM16.9286 12.6964V8.46429H21.1607V12.6964H16.9286ZM21.1607 8.46429V4.23214H25.3929V8.46429H21.1607Z",
    fill: "#FF923E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSr);
export default __webpack_public_path__ + "static/media/SR.0ff11d23f80cdccb7c54fd27f7f3f333.svg";
export { ForwardRef as ReactComponent };